var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6.5C8 4.9087 8.63214 3.38258 9.75736 2.25736C10.8826 1.13214 12.4087 0.5 14 0.5C15.5913 0.5 17.1174 1.13214 18.2426 2.25736C19.3679 3.38258 20 4.9087 20 6.5C20 8.0913 19.3679 9.61742 18.2426 10.7426C17.1174 11.8679 15.5913 12.5 14 12.5C12.4087 12.5 10.8826 11.8679 9.75736 10.7426C8.63214 9.61742 8 8.0913 8 6.5ZM8 15.5C6.01088 15.5 4.10322 16.2902 2.6967 17.6967C1.29018 19.1032 0.5 21.0109 0.5 23C0.5 24.1935 0.974106 25.3381 1.81802 26.182C2.66193 27.0259 3.80653 27.5 5 27.5H23C24.1935 27.5 25.3381 27.0259 26.182 26.182C27.0259 25.3381 27.5 24.1935 27.5 23C27.5 21.0109 26.7098 19.1032 25.3033 17.6967C23.8968 16.2902 21.9891 15.5 20 15.5H8Z",
    fill: "#6E818D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.93e52cf5c8a4e54c67f3b6cd6572a509.svg";
export { ForwardRef as ReactComponent };